module.exports = __webpack_public_path__ + "img/bg1.322194c1.png";